import { formatISO, parse, isValid, format } from 'date-fns';

const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';

export const getParsedDateAsISO = (dateStr: string, dateFormat: string = DEFAULT_DATE_FORMAT) => {
  const parsedDate = parse(dateStr, dateFormat, new Date());
  return formatISO(parsedDate);
};

export const getIsDateValid = (dateStr: string, dateFormat: string = DEFAULT_DATE_FORMAT) => {
  try {
    const parsedDate = parse(dateStr, dateFormat, new Date());
    return isValid(parsedDate);
  } catch {
    return false;
  }
};

export const normalizeBirthDateInput = (str: string) => {
  if (str.includes('T')) {
    return str.split('T')[0];
  }
  return str;
};

export const safeParseDate = (dateStr: string, scheme: string) => {
  if (!dateStr) return '';
  const safeDate = parse(normalizeBirthDateInput(dateStr), 'yyyy-MM-dd', new Date());
  if (!isValid(safeDate)) return '';
  return format(safeDate, scheme);
};
